import { ChangeDetectorRef, Component, HostListener, Inject, Input, LOCALE_ID } from '@angular/core';
import { NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { BnUserContextMenuWidgetExtendedService } from './utils/user-context-menu-widget-extended.service';
import { AccessgroupDataHttpService } from '@backbase/accessgroup-data-http-ang';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  providers: [AccessgroupDataHttpService]
})
export class AppComponent {
  urlPasada = window.location.href;
  isSelectContext = true;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if(event.target.innerWidth > 700 && event.target.innerWidth < 1000) {
      this.isMenuSmall = true;    
    }
    if(event.target.innerWidth > 1000) {
      this.isMenuSmall = false;    
    }
    
  }

  isMenuSmall = false;
  constructor(
    private router: Router, 
    @Inject(LOCALE_ID) private readonly locale: string,
  ) { 
  }

  translateString(es: string, en: string) {
    return this.locale === 'es-DO' ? es : en;
  }

  ngOnInit(): void {
  }
  
  updateMenuState(): void {
    this.isMenuSmall = !this.isMenuSmall;
  }

  redirectToMulticreditoWithdrawal(): void {
    this.router.navigate(['/', 'home', 'multicredito-withdrawal', 'form']);
  }
  redirectToServices(): void {
    this.router.navigate(['/', , 'home', 'services-taxes', 'services', 'form']);
  }
  redirectToCredit(): void {
    this.router.navigate(['/', , 'home', 'credit-cards-in-banesco', 'other-beneficiaries', 'form']);
  }

}

  

  

